import React from "react";

const ReviewAndSend = () => {
  return (
    <div>
      <div className="text-xl font-semibold">Subscription & Pricing</div>

      <div className="mt-4">
        Set up your invoice number, status and payment information.
      </div>
      <div className="mb-3 mt-5">
        <div className="text-[#191919] font-semibold mb-4">
          Terms and Conditions
        </div>
        <textarea
          type="text"
          placeholder="Enter terms and condition here"
          className="w-full h-[100px] border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
        />
      </div>
      <div className="mb-3 mt-5">
        <div className="text-[#191919] font-semibold mb-4">Remarks</div>
        <textarea
          type="text"
          placeholder="Enter remarks here"
          className="w-full h-[100px] border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
        />
      </div>
    </div>
  );
};

export default ReviewAndSend;
